var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickThin = function SvgTickThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "currentColor",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.14 4.61a.375.375 0 010 .53L5.515 7.765a.375.375 0 01-.53 0L3.86 6.64a.375.375 0 11.53-.53l.86.86 2.36-2.36a.375.375 0 01.53 0zM10.875 6a4.875 4.875 0 11-9.75 0 4.875 4.875 0 019.75 0zm-.75 0a4.125 4.125 0 10-8.25 0 4.125 4.125 0 008.25 0z"
  })));
};
export default SvgTickThin;